// components/Testimonial/Testimonial.jsx
import React from 'react';
import './Testimonial.scss';

export default function Testimonial({ testimonial }) {
  if (!testimonial || (!testimonial.quote && !testimonial.author)) return null;
  const { quote, author } = testimonial;

  return (
    <figure className="testimonial-card" aria-label="Client testimonial">
      <div className="testimonial-card__icon" aria-hidden="true">“</div>

      {quote && (
        <blockquote className="testimonial-card__quote">
          {quote}
        </blockquote>
      )}

      {author && (
        <figcaption className="testimonial-card__author">
          <span className="testimonial-card__dash" aria-hidden="true">—</span>
          {author}
        </figcaption>
      )}
    </figure>
  );
}
